module.exports = __webpack_public_path__ + "img/logoWhite.c96aa3b0.png";